import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-start justify-between gap-3" }
const _hoisted_2 = { class: "min-w-0 pr-2 shrink-0" }
const _hoisted_3 = { class: "w-40 shrink-0 md:w-[260px]" }
const _hoisted_4 = { class: "relative overflow-hidden rounded-2xl bg-gray-200" }
const _hoisted_5 = { class: "mt-4 grid grid-cols-2 gap-x-3 gap-y-3 sm:grid-cols-3" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "block"
}
const _hoisted_10 = {
  key: 3,
  class: "block"
}
const _hoisted_11 = { class: "mt-4 flex justify-end" }

import { computed, ref } from "vue";

import { Translations } from "~/js/interfaces/translations";
import { Location } from "~/js/interfaces/locations";
import { getTranslation } from "~/js/composables/translations";
import { getLocationColors } from "~/js/composables/colors";

import Badge from "~/vue/atoms/badges/BadgePrimary.vue";
import ImageTeaser from "~/vue/atoms/images/ImageTeaser.vue";
import TextH4 from "~/vue/atoms/texts/TextH4.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";

interface Props {
	location: Location;
	translations?: Translations | null;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardUnitSidebar',
  props: {
    location: {},
    translations: { default: null },
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const colors = ref(getLocationColors());
const status = computed(() => (props.location.availableNow ? "available" : "soon"));

const trimmedBuildingParts = computed(() => {
	const allowedTypes = ["warehouse", "office", "mezzanine"];
	return props.location.buildingPartTypes.filter((item) => allowedTypes.includes(item.type));
});

const formatArea = (value: unknown): string =>
	String(value ?? "")
		.replace(/\s*m\^?2\s*/gi, "")
		.replace(/\^2/g, "")
		.trim();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(['overflow-hidden rounded-3xl bg-white p-4', __props.utilities])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createVNode(TextH4, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.location.title), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Badge, {
            content: _unref(getTranslation)(__props.translations, __props.location.availableNow ? 'Available now' : 'Available soon'),
            style: _normalizeStyle(colors.value[status.value].badge),
            utilities: "absolute left-2 top-2 z-10 !bg-white !text-viridian-500",
            size: "small"
          }, null, 8, ["content", "style"]),
          (__props.location.teaser)
            ? (_openBlock(), _createBlock(ImageTeaser, {
                key: 0,
                image: __props.location.teaser,
                ratio: "aspect-[12/5] w-full sm:aspect-[4/3]",
                sizes: ['(max-width: 639px) 100vw', '260px']
              }, null, 8, ["image"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trimmedBuildingParts.value, (building) => {
        return (_openBlock(), _createElementBlock("article", {
          key: building.slug,
          class: "min-w-0 text-sm"
        }, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(building.title), 1),
          (building.area)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(formatArea(building.area)) + " m² ", 1))
            : (building.spaces)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(building.spaces), 1))
              : _createCommentVNode("", true),
          (building.price && building.area)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(building.price) + " / m² / " + _toDisplayString(_unref(getTranslation)(__props.translations, "y.")), 1))
            : (building.price && building.spaces)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(building.price) + " / " + _toDisplayString(_unref(getTranslation)(__props.translations, "spot")) + " / " + _toDisplayString(_unref(getTranslation)(__props.translations, "y.")), 1))
              : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(ButtonSecondary, {
        size: "small",
        icon: "arrow-right",
        type: "a",
        "icon-position": "after",
        href: __props.location.url,
        content: _unref(getTranslation)(__props.translations, 'View unit')
      }, null, 8, ["href", "content"])
    ])
  ], 2))
}
}

})